"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var PriceZone_1 = require("../../zone/model/PriceZone");

var AbstractRelease_1 = require("./AbstractRelease");

var PricingType_1 = require("./PricingType");

var ReleaseEditInfo_1 = require("./ReleaseEditInfo");

var ReleasePart_1 = require("./ReleasePart");

var ReleaseType_1 = require("./ReleaseType");
/**
 * Release of new prices. This is main release entity with its own database collection.
 * Release consists mainly from release parts nested within the release (these have separate workflow processed,
 * can be approved and submitted to export individually). Release settings are stored in separate
 * database collection and from release items (the most concrete re-priced unit - related to a product).
 * Release items are not directly part of this class, they are stored in separate collection.
 *
 * <p>
 * Note: There is instance of release settings for each price zone in release, within price zone for each
 * product category in the release and within product category for each product sensitivity (see ReleaseSettingsRepository).
 * </p>
 * <p>
 * Note: Inheriting general settings is default option. Custom settings is typical for simulation release.
 * </p>
 *
 * @author Radek Beran
 */


var Release =
/*#__PURE__*/
function (_AbstractRelease_1$Ab) {
  _inherits(Release, _AbstractRelease_1$Ab);

  /**
   * Creates new release.
   * @param id identifier of release
   * @param name name of release
   * @param description free description of release
   * @param releaseType type of release (regular, simulation, sellout)
   * @param workflowType type of workflow
   * @param state current release state; it is synchronized from individual states of release parts
   * @param pricingType national or local pricing type, or null - unknown
   * @param sourceReleaseId id of source release from which the settings is taken, or null
   * @param priceZoneIds ids of price zones for the release (national price zone that should be also in DB,
   * or local price zone ids, or price zones from another release)
   * @param priceListTypeId price list type id from PriceListSettings
   * @param priceListType price list type from PriceListSettings
   * (type column in https://drive.google.com/file/d/1lkFEQ8Cvv_LdoEm2KWQfKTyG0hqapmI8/view?ts=5c0a66dc)
   * (EDLP, Regular) - id from {@link PriceListType}. Note: Similar info are the flagSet available on the products.
   * @param productCategoryIds product categories that should be processed (included) within the release.
   * These can be not-only top level categories but also some specific lower-level nested categories
   * (only some lower-level categories can be selected). Note: More common is accessing release part categories (via getPartCategoryIds)
   * that are computed based on these productCategoryIds.
   * @param releaseParts parts of release with separate workflow (e.g. approval, submission, ...)
   * @param created time of creation of release entity
   * @param createdBy user who created this release entity
   * @param lastModified time of last modification (last saved)
   * @param lastModifiedBy user who modified this release as last (last saved)
   * @param cmDeadline deadline for the release. Serves for urgencies between CM and SCM/SM, ...
   * @param priceValidityStartDate expected start date of new price validity
   * @param endDate default price validity end date, value is used only for non-urgent EDLP releases, it is distributed to product level
   * @param totalPriceChangeLimit Number of items - limit for maximum number of items with changed prices in the release.
   * This is input value for Yieldigo optimization engine. Optimization engine chooses X articles with the highest benefits.
   * This is not a hard limit for manual inclusion/exclusion of re-priced items and for the export itself.
   * If manual pricing is used, the amount is counted into total price change limit.
   * @param exported date and time of prices export; null if not exported (yet)
   * does not allow another progress
   * @param calcWorkflowCaseId case ID of a workflow which processes initial calculation of optimal prices in the entire release.
   * A state of the release must be ReleaseState. Computing until the workflow is finished.
   * @param exportWorkflowCaseId case ID of a workflow which processes a preparation for release's export.
   * Is null if there has not yet been any export or the last export has been abandoned.
   * @param exportProgressMonitorId ID of a progress monitor associated with this release's export (an evaluation
   * of repricing possibility constraints). If null then the there is currently no such running operation.
   * @param editInfo hints for release editing; loaded only when requested
   * @param favourite indicates whether release is favourite one
   * @param validationResult validation messages (alerts)
   * @param calcProgressMonitorId id of progress monitor for optimal prices calculation
   * @param computingProcessId ID of application instance working with this release (performing price calculations)
   */
  function Release(id, name, description, releaseType, // regular, simulation, sellout ...
  workflowType, state, pricingType, // national or local
  sourceReleaseId, priceZoneIds, priceListTypeId, priceListType, productCategoryIds, releaseParts,
  /** Date and time of release creation (internal field). */
  created, createdBy,
  /** Date and time of last modification. */
  lastModified, lastModifiedBy, cmDeadline, // missing for some workflow types
  priceValidityStartDate, // null in Urgent
  endDate, // filled for non-urgent EDLP releases (LOG-4786)
  totalPriceChangeLimit, // missing for some workflow types
  exported, calcWorkflowCaseId, exportWorkflowCaseId, exportProgressMonitorId, editInfo, favourite, validationResult, realImpact, calcProgressMonitorId, computingProcessId) {
    var _this;

    _classCallCheck(this, Release);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Release).call(this, id, name, description, releaseType, created, createdBy, lastModified, lastModifiedBy, priceListTypeId, priceListType, productCategoryIds, releaseParts, workflowType, state, calcWorkflowCaseId, exportWorkflowCaseId, exportProgressMonitorId, priceValidityStartDate, totalPriceChangeLimit, exported, cmDeadline, favourite, validationResult, realImpact, calcProgressMonitorId, computingProcessId));
    _this.id = id;
    _this.name = name;
    _this.description = description;
    _this.releaseType = releaseType;
    _this.workflowType = workflowType;
    _this.state = state;
    _this.pricingType = pricingType;
    _this.sourceReleaseId = sourceReleaseId;
    _this.priceZoneIds = priceZoneIds;
    _this.priceListTypeId = priceListTypeId;
    _this.priceListType = priceListType;
    _this.productCategoryIds = productCategoryIds;
    _this.releaseParts = releaseParts;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.lastModifiedBy = lastModifiedBy;
    _this.cmDeadline = cmDeadline;
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.endDate = endDate;
    _this.totalPriceChangeLimit = totalPriceChangeLimit;
    _this.exported = exported;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.exportWorkflowCaseId = exportWorkflowCaseId;
    _this.exportProgressMonitorId = exportProgressMonitorId;
    _this.editInfo = editInfo;
    _this.favourite = favourite;
    _this.validationResult = validationResult;
    _this.realImpact = realImpact;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.computingProcessId = computingProcessId;
    return _this;
  }
  /**
   * Returns true if given release is sellout release.
   * Use this method rarely, only in meaningful cases.
   */


  _createClass(Release, [{
    key: "withUpdatedReleaseParts",

    /**
     * Updates release parts using given function and returnes updated release (that can be later stored in DB).
     * @param update
     */
    value: function withUpdatedReleaseParts(update) {
      return this.copy('releaseParts', this.releaseParts.map(function (releasePart) {
        return update(releasePart);
      }));
    }
    /**
     * Returns only approved release parts.
     */

  }, {
    key: "approvedReleaseParts",
    value: function approvedReleaseParts() {
      return this.releaseParts.filter(function (part) {
        return part.approved !== null;
      });
    }
  }], [{
    key: "isRegularRelease",
    value: function isRegularRelease(release) {
      return release.releaseType === ReleaseType_1.ReleaseType.Regular || release.releaseType === ReleaseType_1.ReleaseType.Simulation;
    }
  }, {
    key: "requireRegularRelease",
    value: function requireRegularRelease(release) {
      if (!Release.isRegularRelease(release)) {
        throw new Error("Not implemented for releaseId=".concat(release.id, ", releaseType=").concat(release.releaseType, " (requireRegularRelease)."));
      }

      var regularRelease = release;
      return regularRelease;
    }
    /**
     * <p>
     * Returns minimal price validity start date from release-level priceValidityStartDate (if defined) and from
     * final prices in given release items. If there is no minimum defined, actual date is returned instead.
     * </p>
     * @param priceValidityStartDate Release price validity start.
     * @param releaseItems Tested release items.
     * @param priceZoneIds Price zones for which the prices are checked.
     * @returns resolved minimum price validity start or current date
     */

  }, {
    key: "getMinPriceValidityStartDate",
    value: function getMinPriceValidityStartDate(priceValidityStartDate, releaseItems, priceZoneIds) {
      var minStartDate = priceValidityStartDate;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = releaseItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = item.prices.filter(function (p) {
              return priceZoneIds.contains(p.priceZoneId);
            })[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var price = _step2.value;

              if (price.finalPrice !== null && !minStartDate) {
                minStartDate = price.finalPrice.validFrom;
              } else if (price.finalPrice !== null && price.finalPrice.validFrom.isBefore(minStartDate)) {
                minStartDate = price.finalPrice.validFrom;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return minStartDate ? minStartDate : moment();
    }
  }]);

  return Release;
}(AbstractRelease_1.AbstractRelease);

exports.Release = Release;

Release.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Release.name);
  return Object.assign(Object.assign({}, AbstractRelease_1.AbstractRelease.schemaBase), {
    pricingType: builder.opt(builder.senum('pricingType', PricingType_1.PricingType, CodebookLookupSequence_1.CodebookLookupSequence.ReleasePricingType)),
    sourceReleaseId: builder.opt(builder.lookup('sourceReleaseId', CodebookLookupSequence_1.CodebookLookupSequence.SourceReleaseId)),
    priceZoneIds: builder.listOf(builder.lookup('priceZoneIds', PriceZone_1.PriceZone.PRICE_ZONES_LOOKUP)),
    releaseParts: builder.listOf(builder.obj('releaseParts', ReleasePart_1.ReleasePart.schema, function (mat) {
      return new ReleasePart_1.ReleasePart(mat.releaseId, mat.productCategoryId, mat.workflowCaseId, mat.calcWorkflowCaseId, mat.cmDeadlineMissed, mat.approved, mat.firstApproval, mat.approvedByUserId, mat.approvedByUserName, mat.validationResult, mat.calcProgressMonitorId, mat.readonly, mat.manualPrices);
    })),
    editInfo: builder.opt(builder.obj('editInfo', ReleaseEditInfo_1.ReleaseEditInfo.schema, function (mat) {
      return new ReleaseEditInfo_1.ReleaseEditInfo(mat.settingsEditable);
    })),
    endDate: builder.opt(builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN))
  });
}();